import { ADD_SEGMENT_MODAL_EDITION_MODE } from '../actionTypes';
import { panelLayoutV2Actions } from '../reducer';

export default (isEdition) => (dispatch) => {
    dispatch(panelLayoutV2Actions[ADD_SEGMENT_MODAL_EDITION_MODE](isEdition));
};
